<template>
  <div>
    <div
      class="filter-bar"
      :class="[
        {
          collectionList: type == 1,
        },
      ]"
    >
      <div class="filter-bar--row">
        <div class="filter-bar-pi-point">
          <img
            :src="piPointImage"
            alt="pi-point"
            class="filter-bar-pi-point__icon"
          />
          <div class="filter-bar-pi-point__amount">{{ piPoints }}</div>
        </div>
        <div class="filter-bar-button">
          <div
            v-if="type == 0"
            class="filter-bar-button__sort"
            @click="toggleSort"
          >
            {{ sorts[selectSort].displayText }}
            <img
              src="@/assets/img/triangle-down.svg"
              alt="triangle-image"
              :class="{ 'show-menu': isSortShow }"
            />
          </div>

          <div v-if="type == 1" @click="toTicket" class="icon ticket">
            <img src="@/assets/img/ticket.svg" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showOverlay" @click="closeAll" class="overlay"></div>
    <nav class="nav-sort">
      <v-expand-transition>
        <div v-show="isSortShow" class="filter-container">
          <div class="row-sort">
            <div
              v-for="(sort, key) in sorts"
              :key="key"
              v-ripple
              class="col col-12"
              :class="{ selected: sort.value === selectSort }"
              @click="selectedSort(sort.value)"
            >
              {{ sort.text }}
            </div>
          </div>
        </div>
      </v-expand-transition>

      <!-- <v-expand-transition>
        <div v-show="isAreaShow" class="filter-container">
          <div class="row-sort">
            <div
              v-for="(area, key) in areas"
              :key="key"
              v-ripple
              class="col col-12"
              :class="{ selected: area.value === selectArea }"
              @click="selectedArea(area.value)"
            >
              {{ area.name }}
            </div>
          </div>
        </div>
      </v-expand-transition> -->
    </nav>
  </div>
</template>

<script>
const sorts = [
  { text: '推薦', value: 0, displayText: '推薦' },
  { text: '最新', value: 1, displayText: '最新' },
  { text: '銷量', value: 2, displayText: '銷量' },
  { text: '折數', value: 3, displayText: '折數' },
  { text: '價格從低到高', value: 5, displayText: '價格' },
  { text: '價格從高到低', value: 4, displayText: '價格' },
]
export default {
  name: 'SortBar',
  components: {},
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data: function() {
    return {
      sorts,
      areas: [{ name: '全部地區', value: 0 }],
      selectArea: 0,
      selectSort: 0,
      isAreaShow: false,
      isSortShow: false,
      filterImage: require('@/assets/img/icon/filter.svg'),
      triangleImage: require('@/assets/img/triangle-down.svg'),
      piPointImage: require('@/assets/img/icon/pi-point.svg'),
      piPoints: 0,
      showOverlay: false,
    }
  },
  methods: {
    toTicket() {
      this.$router.push({ name: 'orderListTicket' })
    },
    closeAll() {
      this.isAreaShow = false
      this.isSortShow = false
      this.showOverlay = false
    },
    selectedArea(value) {
      if (value !== this.selectArea) {
        // this.getProducts('area', true)
        this.selectArea = value
      }
      this.isAreaShow = false
      this.showOverlay = false
    },
    selectedSort(value) {
      if (value !== this.selectSort) {
        this.selectSort = value
        this.$emit('sort', value)
        // this.getProducts('sort', true)
      }
      this.isSortShow = false
      this.showOverlay = false
    },
    toggleSort() {
      this.isAreaShow = false
      this.isSortShow = !this.isSortShow
      this.showOverlay = this.isSortShow
    },
    toggleArea() {
      this.isSortShow = false
      this.isAreaShow = !this.isAreaShow
      this.showOverlay = this.isAreaShow
    },
  },
  mounted() {
    const piInfo = localStorage.getItem('PI_POINTS')
    if (piInfo != null) this.piPoints = piInfo
  },
  watch: {
    showOverlay(newVal) {
      this.$emit('overlay', newVal)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-bar {
  margin-bottom: 1px;
  padding: 10px 18px;
  height: 48px;
  background: white;
  box-shadow: 0 1px 0 0 #dddddd;
  z-index: 12;
  position: fixed;
  width: 100%;
  top: 65px;
  box-shadow: inset 0 -1px 0 0 #dddddd, inset 0 1px 0 0 #dddddd;
  &.collectionList {
    top: 0;
  }
  &--row {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-pi-point {
    height: 30px;
    padding: 5px 10px;
    border-radius: 24px;
    border: solid 1px #bbbbbb;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1da7fc;
    display: flex;
    align-items: center;

    &__icon {
      width: 16px;
      height: 18px;
    }

    &__amount {
      margin-left: 2px;
    }
  }

  &-button {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__sort {
      height: 20px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.44px;
      text-align: right;
      color: #383838;
      vertical-align: middle;
      display: flex;

      img {
        margin-left: 5px;
        transition: 300ms;

        &.show-menu {
          transform: rotate(180deg);
          transition: 300ms;
        }
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      img {
        width: 100%;
      }
    }
  }
}
.filter-container > {
  transition: all 0.2s ease;
  .row {
    padding: 0 10px;
    max-height: 384px;
    overflow-y: scroll;
    z-index: 999;
  }
  .row-sort {
    padding: 0 10px;
    max-height: 282px;
    overflow-y: scroll;
    z-index: 999;
  }
}
.filter-container .col {
  padding-left: 16px;
  padding-right: 23px;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #545454;

  &.selected {
    color: #1da7fc;
  }
}
.filter-container .col img {
  float: right;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0.46;
  background-color: rgb(33, 33, 33);
  width: 100%;
  height: 100vh;
  z-index: 11;
}

.nav-sort {
  padding: 0 12px;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 19;
  border-top-right-radius: 1rem;
  border-top-left-radius: 1rem;
}
</style>
